// extracted by mini-css-extract-plugin
export default {"heading":"ToolboxPage_heading__smFuP","tools":"ToolboxPage_tools__pWcna","toolSection":"ToolboxPage_toolSection__EO9RF"};